// extracted by mini-css-extract-plugin
export default {"row":"oB60pjv_qE7wHjfgZSHD","fiberCell":"adaSLiVm6W64IKIKcJwD","value":"PIVOP_HvKgRE_O8Gu0on","description":"Wfv5hmW72SLILLnecif4"};